import { matchPath } from "react-router-dom";
import ITab from "interfaces/Tab";

export const getTabFromPath = (pathname: string, tabsList: ITab[]): ITab => {
  return (
    tabsList.find(t =>
      matchPath(pathname, {
        path: t.path,
        exact: true,
        strict: true
      })
    ) || tabsList[1]
  );
};
